import React, { useState, useEffect } from "react";
import { postData } from "../../../../../ApiServices/ApiService";
import { ORG_INVOICE } from "../../../../../ApiServices/BaseURL";

const InvoiceReceiptNotesController = (narrationText, notesText, errorSettings, onRefresh) => {
    const [narration, setNarration] = useState("");
    const [notes, setNotes] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [narrationError, setNarrationError] = useState("");
    const [notesError, setNotesError] = useState("");

    useEffect(() => {
        setNarration(narrationText || "");
        setNotes(notesText || "");
        setError(errorSettings);
    }, [narrationText, notesText, errorSettings]);

    const handleUpdateReceiptNarration = async () => {

        try {
            setError('');
            setSuccess('');
            setNarrationError("");
            setNotesError("");

            if (!narration) {
                setNarrationError("Please enter the narration");
                return;
            }

            if (!notes) {
                setNotesError("Please enter the notes");
                return;
            }

            setLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "emp_id_auth": storedUserInfo?.emp_id,
                "action": "NARRATION_NOTES_UPDATE",
                "acc_narration": narration,
                "acc_notes": notes,
            }

            //console.log('handleUpdateTaskType Data', payLoad);
            // Make the API call
            const response = await postData(ORG_INVOICE, payLoad);
            const responseData = await response.json();
            //console.log('handleUpdateTaskType response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setSuccess(responseData?.info);
                        setTimeout(() => {
                            setSuccess('');
                            setIsEditing(false);
                            onRefresh();
                        }, 3000);
                    } else {
                        setError(responseData?.info || 'Failed to Update Task Type data. Please try again.');
                    }
                } else {
                    setError(responseData?.info || 'Failed to Update Task Type data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setLoading(false);
        }


        // onValueChange(clientData); // Send data to Dashboard
        // onClose(); // Close modal
    };

    return {
        narration,
        setNarration,
        notes,
        setNotes,
        handleUpdateReceiptNarration,
        loading,
        error,
        success,
        isEditing,
        setIsEditing,
        narrationError,
        notesError,
    };
}

export default InvoiceReceiptNotesController;
